import React, { useState, useEffect } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Typography,
  Card,
  CardMedia,
  CardContent,
  CardActions,
} from "@mui/material";
import { BrandContext } from "../../App";
import { useTheme } from "@mui/material/styles";
import HomeProgramCard from "../../components/complex/HomeProgramCard";
import PreviousResultsChart from "../../components/complex/PreviousResultsChart";

import PageTitle from "../../components/PageTitle/PageTitle";

import Tooltip from "@mui/material/Tooltip";
import HelpTooltip from "../../components/CallScreen/HelpTooltip";

export default function DashboardHome() {
  const theme = useTheme();
  const { brand, user } = React.useContext(BrandContext);
  const [sites, setSites] = React.useState([]);

  const navigate = useNavigate();

  React.useEffect(() => {
    document.title = `${user.first_name}'s Dashboard - ${brand.name}`;
  }, [user.first_name, brand.name]);

  return (
    <React.Fragment>
      {user.first_name && <PageTitle text={`Welcome, ${user.first_name}!`} />}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          margin: 0,
        }}
      >
        <HomeProgramCard />
        <PreviousResultsChart />
      </Box>
    </React.Fragment>
  );
}
